import { createRoot } from 'react-dom/client'
import ThemeProvider from '@talkdesk/cobalt-react-theme-provider'
import ViewportProvider from '@talkdesk/cobalt-react-viewport-provider'
import PortalProvider from '@talkdesk/cobalt-react-portal-provider'
import { IconsProvider } from '@talkdesk/cobalt-react-icon'
import theme from '@talkdesk/cobalt-theme-light'
import Root from './root'
import '../assets/stylesheet.css'
import context from './config/context'
import { ErrorBoundary } from 'react-error-boundary'

window.TalkdeskApps = window.TalkdeskApps || {}

let appRoot = null

window.TalkdeskApps.TalkdeskId = {
  start: function (rootElement, params) {
    initContext(params)
    startApp(rootElement, params)
  },
  stop: function () {
    if (appRoot) {
      appRoot.unmount()
      appRoot = null
    }
  },
  version: __APP_VERSION__,
}

// TODO: Deprecate after TD-ID sets the keys in the document.context
const initContext = ({
  brandAssetsURL,
  talkdeskIdAssetsURL,
  csrfToken,
  tenantId,
  splitIoKeyUI,
  passwordPolicies,
  showGoogleFooterLink,
}) =>
  Object.assign(context, {
    brandAssetsURL: brandAssetsURL || context.brandAssetsURL,
    talkdeskIdAssetsURL: talkdeskIdAssetsURL || context.talkdeskIdAssetsURL,
    csrfToken: csrfToken.token || context.csrfToken,
    tenantId: tenantId || context.tenantId,
    splitIoKeyUI: splitIoKeyUI || context.splitIoKeyUI,
    passwordPolicies: passwordPolicies || context.passwordPolicies,
    showGoogleFooterLink: showGoogleFooterLink || context.showGoogleFooterLink,
  })

function startApp(rootElement, { ...params }) {
  const { user, siteKey, themeVersion } = params

  let themeLoader
  if (themeVersion) {
    console.log(`Using theme version: ${themeVersion}`)
    themeLoader = () => Promise.resolve(null)
  } else {
    console.log('Using default theme')
    themeLoader = () => Promise.resolve(theme)
  }
  appRoot = createRoot(rootElement)
  appRoot.render(
    <ErrorBoundary
      onError={(error) =>
        console.log(`Error name: ${error.name}, message: ${error.message}`)
      }
    >
      <ThemeProvider loader={themeLoader}>
        <IconsProvider>
          <PortalProvider>
            <ViewportProvider>
              <Root user={user} siteKey={siteKey} />
            </ViewportProvider>
          </PortalProvider>
        </IconsProvider>
      </ThemeProvider>
    </ErrorBoundary>,
  )
}
